import { isValidElement } from 'react';
const getDisplayName = (child) => {
    if (isValidElement(child)) {
        if (
        // @ts-ignore 2339
        child.type.type
            // @ts-ignore 2339
            && child.type.type.displayName) {
            // @ts-ignore 2339
            return child.type.type.displayName;
        }
        // @ts-ignore 2339
        return child.type.displayName;
    }
    return '';
};
export { getDisplayName };
